<template>
  <span>
    <a
      v-if="isValidJsonString"
      :href="experienceLink"
      target="_blank"
      class="experience-link"
    >
      {{ experience.name }}
    </a>
    <span v-else>Invalid Experience</span>
  </span>
</template>
<script>
export default {
  props: {
    /**
     * A JSON string for a JavaScript array with 2 values:
     * 1. A string for experience name
     * 2. A string for the experience ID
     */
    experienceJsonString: {
      type: String,
      required: true,
    },
  },
  computed: {
    experienceLink() {
      return `/attach-studio/preview/${this.experience.id}`;
    },
    isValidJsonString() {
      return this.experience.name !== undefined
        && this.experience.name !== null
        && this.experience.id !== undefined
        && this.experience.id !== null;
    },
    experience() {
      try {
        const [name, id] = JSON.parse(this.experienceJsonString);

        return {
          name,
          id,
        };
      } catch (e) {
        return {
          name: null,
          id: null,
        };
      }
    },
  },
};
</script>

<style scoped>
.experience-link {
  word-break: break-all;
}
</style>
